import { QueryPart, QueryPartStrategy, ShSearchRoutingService } from '@stylehaven/components';
import { SimpleType } from '../../entities/common/simple-type.entity';

export class MHSearchRoutingService extends ShSearchRoutingService {
    private readonly searchRoute: string;

    constructor(defaultSearchRoute: string) {
        super();
        this.searchRoute = defaultSearchRoute;
    }

    getSearchRouterLink(): string[] {
        return [this.searchRoute];
    }

    getTermRouterLinkState(fieldKey: string, value: SimpleType): { [k: string]: any } {
        if (value === null) {
            return {};
        }

        const queryParts: QueryPart[] = [
            new QueryPart({
                field: fieldKey,
                strategy: QueryPartStrategy.MatchAll,
                values: [value.toString()]
            })
        ];

        return { queryParts };
    }
}
